import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVersusCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVersusCircle"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/><Path d="M17.0001 10V8.5H13.5V12H17.0001L17 15.5H13.5L13.5 14" stroke="currentColor"/><Path d="M10.5 8V13.5L9 15.5H8L6.5 13.5V8" stroke="currentColor"/></CentralIconBase>;
});

export default IconVersusCircle;
